import React, { useState, useEffect } from 'react';
import { Avatar } from '@mui/material';
import heic2any from "heic2any";

const convertHeic = async (src) => {
        try {
          const response = await fetch(src);
          const blob = await response.blob();
          const convertedBlob = await heic2any({
            blob,
            toType: "image/jpeg",
          });
          const url = URL.createObjectURL(convertedBlob);
          return url;
        } catch (e) {
          console.error("HEIC conversion failed", e);
        }
      };

    export default convertHeic;
